import { notFound } from "@/assets/lottie";
import Lottie from "lottie-react";
import React from "react";

const NotFound = (params: { className?: string; text?: string }) => {
  return (
    <div
      className={`flex flex-col gap-4 justify-center items-center ${
        params.className || "text-white "
      }`}
    >
      <div className="w-[250px]">
        <Lottie animationData={notFound} loop />
      </div>
      <span className="font-bold text-black">{params.text || "Not Found"}</span>
    </div>
  );
};

export default NotFound;
